var React = require('react');

function KbdArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 8L11.087 13 11.087 8.856 0 8.856 0 7.144 11.087 7.144 11.087 3z"}));
}

KbdArrowRight.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = KbdArrowRight;

KbdArrowRight.default = KbdArrowRight;
